export enum CLIENT_PLAN_TYPES {
  STANDARD = 'Standard',
  PLATINUM = 'Platinum',
  FREE = 'Free',
  LITE = 'Lite',
  VIP = 'Vip',
  DEEL = 'Deel'
}

export enum CLIENT_TYPES {
  CLIENT = 1,
  PARTNER = 2
}

export enum CLIENT_PLAN_SUBSCRIPTIONS {
  'Free' = 'Standard',
  'Lite' = 'Platinum',
  'Vip' = 'Vip'
}

export type TClient = CLIENT_PLAN_TYPES.STANDARD | CLIENT_PLAN_TYPES.PLATINUM | CLIENT_PLAN_TYPES.DEEL;
export type TClientType = CLIENT_TYPES.CLIENT | CLIENT_TYPES.PARTNER;
